const test = false;
//production publish on pre-production domain to be tested before production
const preprod = false;
export const Config = {
    test: preprod ? false : test,//force test param in false when it is pre-production
    preprod: preprod,
    version: require('../package.json').version,
    preferredCountry: 'it',
    platform: 'web',
    portal: 'sci',
    app: 'sci',
    language: 'it',
    hostUrl: preprod ? 'https://user-preprod.mypass.ski/proxy.php?csurl=https://services.mypass.technology/MPLumenAPI/v1/' :
        test ? 'https://user-test.mypass.ski/proxy.php?csurl=https://services.mypass.technology/MPLumenAPI.test/sci/' :
            'https://user.mypass.ski/proxy.php?csurl=https://services.mypass.technology/MPLumenAPI/v1/',

    // hostUrl:'https://services.mypass.technology/MPLumenAPI.test/sci/',
    servicePrice: 39,// 39 euro for this promo
};
